// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button___fa9b","list":"styles_list__1rKfb"};